import React, { useState } from 'react';
import './projects.css';
import image1 from "./images/redRadio.jpg";
import image2 from "./images/logo2.png";
import image3 from "./images/CD_COVER_2.png";
import image4 from "./images/logo.png"
import image5 from "./images/agrosmart.jpeg"
import image6 from "./images/EduFlexcopy.png"
import image7 from "./images/EduSmartpng.png"
import { Link } from 'react-router-dom';
const projects = [
  {
    id: 1,
    title: 'Red-Radio',
    description: 'Desktop Application',
    image: image1,
    demoLink: "/RedRadio",
    githubLink: 'https://github.com/OuhabYouceff/Boutelliss-SDL-2DGame',
  },
  {
    id: 2,
    title: 'Calmini',
    description: 'Web Application',
    image: image2,
    demoLink:"/Calmini",
    githubLink: 'https://github.com/OuhabYouceff/RedRadio-Qt-App',
  },
  {
    id: 3,
    title: 'Boutellis',
    description: '2D Game',
    image: image3,
    demoLink: "/Boutellis",
    githubLink: 'https://github.com/OuhabYouceff/Calmini-PHP-App',
  },
  {
    id: 4,
    title: 'AeroLink',
    description: 'Data Science/BI Project',
    image: image4,
    demoLink: "/AeroLink",
    githubLink: '',
  },
  {
    id: 5,
    title: 'AgroSmart',
    description: 'Currently In Development',
    image: image5,
    demoLink: "/AgroSmart",
    githubLink: '',
  },
  {
    id: 6,
    title: 'EduSmart',
    description: 'Currently In Development',
    image: image7,
    demoLink: "/EduSmart",
    githubLink: '',
  },
  {
    id: 7,
    title: 'EduFlex',
    description: 'Currently In Development',
    image: image6,
    demoLink: "/EduFlex",
    githubLink: '',
  }
  
  // Add more project objects as needed
];

const ProjectList = () => {
  const [showAll, setShowAll] = useState(false);
  
  const initialProjects = projects.slice(0, 3);
  const additionalProjects = projects.slice(3);

  const displayedProjects = showAll ? projects : initialProjects;

  return (
    <section className="portfolio section" id='portfolio'>
    <div className="project-list" >
      <h2 className="section__title" >Academic Projects</h2>
      <span className="section__subtitle">Not the best..but have a look!</span>
      <div className="project-list__container ">
        {displayedProjects.map((project) => (
          <div className="project" key={project.id}>
            <div className="project__image">
              <img src={project.image} alt={project.title} />
            </div>
            <div className="project__content">
              <h3 className="project__title">{project.title}</h3>
              <p className="project__description">{project.description}</p>
              <div className="project__links">
                <Link to={project.demoLink} className='links__projects'>Details</Link>
                {/* <a href={project.githubLink} className='links__projects' target="_blank" rel="noopener noreferrer">GitHub</a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {additionalProjects.length > 0 && (
        <div className="projects__toggle">
          <button 
            className="button button--small projects__button"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </div>
    </section>
  );
};

export default ProjectList;
